import { FC, useMemo } from 'react'
import { Link } from '@mui/material'
import { AgencyTypeValues } from '../../../../constants/AgencyType'
import { Location } from '../../../../api/models'
import { getPermitOrdinanceUrl } from '../../../../utils/permitUtils'

export const OrdinanceLink: FC<{ location: Location; agencyType: AgencyTypeValues }> = ({ agencyType, location }) => {
  const url = getPermitOrdinanceUrl(location, agencyType)

  const fixedUrl = useMemo(() => {
    const trimmedUrl = url.trim().toLowerCase()
    return trimmedUrl.startsWith('http') ? trimmedUrl : `http://${trimmedUrl}`
  }, [url])

  if (url) {
    return (
      <Link href={fixedUrl} target={'_blank'} rel="noopener">
        Ordinance
      </Link>
    )
  } else {
    return <>Not available</>
  }
}
